import { Preferences } from '@algoan/dashboard/model';
import { updateAuthInformation } from './auth-slice';
import { parseJwtPayload } from '@algoan/dashboard/utils';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const getInitialState = (): Preferences => ({});

const initialState = getInitialState();

const preferencesSlice = createSlice({
  name: 'preferences',
  initialState,
  reducers: {
    toggleSkipOnboarding(state: Preferences) {
      state.skipOnboarding = !state.skipOnboarding;
    },
    updateFavoriteProject(state: Preferences, action: PayloadAction<string | undefined>) {
      state.favoriteProject = action.payload ?? '';
    },
  },
  extraReducers: (builder) => {
    builder.addCase(updateAuthInformation, (state, action) => {
      if (typeof action.payload === 'undefined') {
        // the preferences should be kept on logout
        return state;
      } else {
        const jwt = parseJwtPayload(action.payload.access_token);
        return { ...state, favoriteProject: jwt.favoriteProject };
      }
    });
  },
});

export const { reducer: preferencesReducer } = preferencesSlice;
export const { toggleSkipOnboarding, updateFavoriteProject } = preferencesSlice.actions;
